
export class WpPerson {
    constructor(
        public id?: number,
        public firstName?: string,
        public lastName?: string,
        public ssn?: string,
        public dobDt?: any,
        public buid?: number,
        public sufxName?: string,
        public prefixName?: string,
        public midName?: string,
        public genderCd?: string,
        public ieClientId?: number,
        public raceCd?: string,
        public instSchoolTypeCd?: string,
        public educationLevelCd?: string,
        public email?: string,
        public addressTypeCd?: string,
        public addrAptNum?: string,
        public addrStNum?: string,
        public addrStNumFrac?: string,
        public addrStName?: string,
        public addrLine?: string,
        public addrCity?: string,
        public addrZip5?: string,
        public addrZip4?: string,
        public addrCountyCd?: number,
        public residentialPhone?: string,
        public messagePhone?: string,
        public workPhone?: string,
        public residentialCounty?: string,
        public primaryLanguage?: string,
        public secondaryLanguage?: string,
        public contactMethod?: string,
        public residentialAddrLine1?:string,
        public residentialAddrLine2?:string,
        public residentialAddrCity?:string,
        public residentialAddrState?:string,
        public residentialAddrZip5?:string,
        public mailingAddrLine1?:string,
        public mailingAddrLine2?:string,
        public mailingAddrCity?:string,
        public mailingAddrState?:string,
        public mailingAddrZip5?:string,
        public recordVersion?:any,
        public serviceCounty?:any,
        public textMessageSw ?: any,
        public preferredPhone ?: any,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/wp-person.model.ts